import React from "react";

const KahaLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <svg
        className="w-12 h-18"
        width="48"
        height="72"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Your SVG paths go here */}
      </svg>
      <div className="flex mt-2">
        <div className="w-3 h-3 mr-1 bg-green-500 rounded-full animate-blink"></div>
        <div className="w-3 h-3 mr-1 bg-green-500 rounded-full animate-blink"></div>
        <div className="w-3 h-3 mr-1 bg-green-500 rounded-full animate-blink"></div>
        <div className="w-3 h-3 bg-green-500 rounded-full animate-blink"></div>
      </div>
    </div>
  );
};

export default KahaLoader;
